<template>
  <div id="app">
    <loading :active.sync="isLoading"
             :is-full-page="fullPage">
      <div>
        <img alt="logo" src="./assets/img/logo.svg" class="logo">
      </div>
      <div class="text-center">
        <svg width="200" height="100" viewBox="0 0 200 100">
        <defs>
          <filter id="goo">
            <feGaussianBlur in="SourceGraphic" stdDeviation="7" result="blur" />
            <feColorMatrix in="blur" mode="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 17 -7" result="cm" />
            <feComposite in="SourceGraphic" in2="cm"/>
          </filter>
          <filter id="f2" x="-200%" y="-40%" width="400%" height="200%">
            <feOffset in="SourceAlpha" dx="9" dy="3" />
            <feGaussianBlur result="blurOut" in="offOut" stdDeviation="0.51" />
            <feComponentTransfer>
              <feFuncA type="linear" slope="0.05" />
            </feComponentTransfer>
            <feMerge>
              <feMergeNode/>
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
        </defs>
        <g filter="url(#goo)" style="fill:#FFFFFF">
          <ellipse id="drop" cx="50" cy="45" rx="20" ry="20" fill-opacity="1" fill="#7D6AED"/>
          <ellipse id="drop2" cx="65" cy="45" rx="20" ry="20" fill-opacity="1" fill="#7D6AED"/>
        </g>
      </svg>
      </div>
    </loading>
    <router-view v-if="!isLoading"/>
  </div>
</template>


<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import firebase from "firebase/app";
import { connectToExtension } from './helpers/utils'

const loader = {
  isLoading: true
};

export default {
  name: "App",
  data() {
    return {
      isLoading: loader.isLoading,
      fullPage: true
    }
  },
  components: {
    Loading
  },
  methods: {
    checkUser () {
      firebase.auth().onAuthStateChanged((user) => {
        const query = this.$router.currentRoute.query;
        if (user && !query.testNavigation) {
          connectToExtension(user.uid, false, () => {
            this.isLoading = false;
            const isRemote = localStorage.getItem('isRemote');
            const needToRedirect = isRemote && !JSON.parse(isRemote) && this.$route.path === '/login';
            if (needToRedirect) {
              this.$router.push('/');
            }
          })
        } else {
          this.isLoading = false;
        }
      })
    }
  },
  created() {
    this.checkUser()
  },
};
</script>

<style lang="scss">
#drop {
  animation: slidein 1s infinite alternate ease-in-out;
}
#drop2 {
  animation: slidein2 1s -0.5s infinite alternate ease-in-out;
}
@keyframes slidein {
  from {
    transform: translate(30px, 10px) scale(0.8)
  }
  to {
    transform: translate(-30px, -10px) scale(1.2)
  }
}
@keyframes slidein2 {
  from {
    transform: translate(30px, 30px) scale(0.4)
  }
  to {
    transform: translate(-30px, -30px) scale(1.6)
  }
}

.vld-overlay .vld-background {
  opacity: 1;
}
</style>